import { useImpersonation } from '@/contexts/ImpersonationContext'
import { AlertTriangle } from 'lucide-react'
import { Button } from '@/components/ui/button'

export function ImpersonationBanner() {
  const { isImpersonating, impersonatedUser, exitImpersonation } = useImpersonation()

  if (!isImpersonating || !impersonatedUser) return null

  return (
    <div
      className="sticky top-0 z-50 w-full flex items-center justify-between px-4 py-2 text-sm font-medium"
      style={{ background: 'hsl(var(--copper))', color: '#fff' }}
    >
      <div className="flex items-center gap-2">
        <AlertTriangle className="h-4 w-4 shrink-0" />
        <span>
          You are impersonating{' '}
          <strong>
            {impersonatedUser.name} ({impersonatedUser.email})
          </strong>
        </span>
      </div>
      <Button
        size="sm"
        variant="outline"
        className="border-white/60 text-white hover:bg-white/20 hover:text-white"
        onClick={exitImpersonation}
      >
        Exit Impersonation
      </Button>
    </div>
  )
}
